import React from 'react'

const OtherServices = () => {
  return (
    <div>
      <section class="unique-services">
        <div class="container">
          <h2>Other Services</h2>
          <p class="intro">
            We provide more than just the core solutions needed for your online
            business to thrive. Our other services are geared toward supporting
            your digital objectives, strengthening your brand presence, and
            delivering value. Explore our other services below:
          </p>

          <div class="services-steps">
            <div class="step">
              <div class="step-number">01</div>
              <div class="step-content">
                <h3>Virtual Learning</h3>
              </div>
            </div>
            <div class="step">
              <div class="step-number">03</div>
              <div class="step-content">
                <h3>Content Writing</h3>
              </div>
            </div>
            <div class="step">
              <div class="step-number">04</div>
              <div class="step-content">
                <h3>Search Engine Optimisation</h3>
              </div>
            </div>
          </div>
        </div>

        <style>
          {`
        .unique-services {
      background: #fff;
      padding: 80px 20px;
      color: #18336c;
    }   

    .unique-services h2 {
      text-align: center;
      margin-bottom: 1rem;
    }

    .intro {
      text-align: center;
      color: #4b5563;
      margin-bottom: 3rem;
    }

    .services-steps {
      display: flex;
      flex-direction: column;
      gap: 2rem;
    }

    .step {
      display: flex;
      align-items: flex-start;
      background: #f5f9ff;
      padding: 1.5rem;
      border-radius: 1rem;
      box-shadow: 0 6px 18px rgba(0, 0, 0, 0.05);
      border: 2px dotted #18336c;
      position: relative;
      overflow: hidden;
      transition: transform 0.3s ease;
    }

    .step:hover {
      transform: scale(1.02);
    }

    .step-number {
      font-size: 2rem;
      font-weight: 700;
      color: white;
      background: #18336c;
      padding: 0.5rem 1.2rem;
      border-radius: 8px;
      margin-right: 1.5rem;
      flex-shrink: 0;
      box-shadow: 0 3px 10px rgba(0,0,0,0.15);
    }

    .step-content h3 {
      font-size: 1.4rem;
      font-weight: 600;
      margin-bottom: 0.5rem;
    }

    .step-content p {
      font-size: 1rem;
      color: #4b5563;
      line-height: 1.5;
    }

    @media (max-width: 600px) {
      .step {
        flex-direction: column;
        align-items: flex-start;
      }

      .step-number {
        margin-bottom: 0.8rem;
        margin-right: 0;
      }
    }
    `}
        </style>
      </section>
    </div>
  );
}

export default OtherServices
